import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import "./index.css";
import store from "./store";
import RoutingPage from "./Routing";
import { theme } from "./config/MuiTheme";
import Toast from "./utils/tostr";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Toast />
       <RoutingPage />
    </ThemeProvider>
  </Provider>
);
